import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { Workforce } from '@indutrust/factory-model';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';

/**
 * API client for the `workforces` sub-resource nested under a factory
 * capability —
 * `/factories/{factoryId}/capabilities/{capabilityId}/workforces`.
 *
 * Call inherited CRUD methods with
 * `urlSegments: { factoryId: <fid>, capabilityId: <cid> }`.
 */
@Service()
export class WorkforceApiClient extends BaseApiClient<Workforce> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template: Partial<Workforce> = {};

  get url(): string {
    return `${this.envService.getApiUrl()}/factories/{factoryId}/capabilities/{capabilityId}/workforces`;
  }
}
